<template>
  <AppSection id="invoices" type="page" :title="$t($getConst.pages.invoice.add_invoice)">
    <InvoiceForm></InvoiceForm>
  </AppSection>
</template>

<script>
  import InvoiceForm from "../InvoiceForm";
  import AppSection from "../../../components/common/sections/AppSection";

  export default {
    name: "index",
    components: {AppSection, InvoiceForm}
  }
</script>

<style scoped>

</style>
